import { render } from "./NcrmDemoDataBanner.vue?vue&type=template&id=5affb954&scoped=true"
import script from "./NcrmDemoDataBanner.vue?vue&type=script&lang=js"
export * from "./NcrmDemoDataBanner.vue?vue&type=script&lang=js"

import "./NcrmDemoDataBanner.vue?vue&type=style&index=0&id=5affb954&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5affb954"]])

export default __exports__